import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, CanActivate, Router } from "@angular/router";
import {
  MotorDataDataService,
  MsdRequestData
} from "src/app/share/data-service/motor.data.service";
import { FieldData } from "src/app/share/interface/common.interface";
import { AlertService } from "src/app/share/service/alert.service";
import { PartnerService } from "src/app/share/service/partner.service";
import { PartnerDataService } from "src/app/share/service/partnerData.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ApproveApplicationComponent } from "../../../components/approve-application/approve-application.component";
import { RejectApplicationComponent } from "../../../components/reject-application/reject-application.component";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IAvailableBanners } from "src/app/share/interface/motor.interface";
import { catchError, tap, throwError } from "rxjs";
import { AuthService } from "src/app/share/service/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import { LoadingOverlayService } from "src/app/share/service/loading-overlay.service";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"]
})
export class ForgotPasswordComponent implements OnInit {
  id: string;
  partnerCode: string;

  data: MsdRequestData;

  summaryList: FieldData[] = [];
  documentList: any[] = [];
  printDocument: any;

  terms: number[] = Array.from({ length: 6 }, (_, i) => i + 1);

  datePipe = new DatePipe("en-GB");

  activeTabIndex = 0;

  formGroup: FormGroup;
  hide: boolean = true;
  availableBanners: IAvailableBanners[] = [];
  loadedBanners: number = 0;
  bannerLink: string = "https://storage.googleapis.com/ps-asset/affiliate/landing/kopetro-banner_1-en.png";
  approverId: string = "";

  	success: boolean;

  


  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private loadingService: LoadingOverlayService,
    private motorDataDataService: MotorDataDataService,
    public alertService: AlertService,
    private router: Router,
    

  ) {
    this.id = this.activatedRoute.snapshot.params.id;
    if (this.authService.isLoggedIn()) {
      this.approverId = this.authService.getUserId();
    }
  }

  ngOnInit(): void {
    this.initForm();
  }

  

  private initForm(): void {
      this.formGroup = this.formBuilder.group({
        email: [null, [Validators.required, Validators.email]]
});
  }

  reset() {}


  goToLogin() {
    if (this.formGroup.invalid) return;
		let value = this.formGroup.value;

    this.motorDataDataService
			.sendForgotPasswordEmail(value.email, this.activatedRoute.snapshot.queryParams.returnPath)
			.subscribe({
				next: (x) => {
					this.loadingService.setLoading(false);
					this.success = true;
          this.alertService.openSnackBar("Emel untuk menetapkan semula kata laluan telah dihantar. Sila periksa emel anda dan ikut arahan yang diberikan.");
          this.redirectToPage();
				},
				error: (err) => {
					this.loadingService.setLoading(false);
					this.success = false;
					this.alertService.openSnackBar("Email not found");
				},
			});
	}
  

    private redirectToPage() {
		this.router.navigate(['/login'], {
    queryParams: {
      returnUrl: this.activatedRoute.snapshot.queryParams.returnPath,
      partnerCode: this.activatedRoute.snapshot.queryParams.partnerCode
    }
});
	}
}
